import React from "react";
import { useState } from "react";
import "./services.css";

const Services = () => {

    const [toggleState, setToggleState] = useState(0);

    const toggleTap=(index)=>{
        setToggleState(index);
    }
  return (
    <section className="services section" id="services">
      <h2 className="section__title">Services</h2>
      <span className="section__subtitle">What i offer </span>

      <div className="services__container container grid">

        <div className="services__content">
          <i className="bx bxl-flutter services__icon"></i>
          <h3 className="services__title">
            Flutter <br /> Developer
          </h3>
          <span className="services__button" onClick={()=>toggleTap(1)}>
            View More
            <i className="uil uil-arrow-right services__button-icon"></i>
          </span>
          <div className={toggleState===1?"services__modal active-modal":"services__modal"} onClick={()=>toggleTap(0)}>
            <div className="services__modal-content">
              <i className="bx bx-x services__modal-close"onClick={()=>toggleTap(0)}></i>
              <h3 className="services__modal-title">Flutter Developer</h3>
              <p className="services__modal-description">
                Service with more than 3 years of experience. providing quality
                work to clients and companies.{" "}
              </p>

              <ul className="services__modal-services grid">
                <li className="services__modal-service">
                  <i className="uil uil-check-circle services__modal-icon"></i>
                  <p className="services__modal-info">
                    develop the user interface.
                  </p>
                </li>

                <li className="services__modal-service">
                  <i className="uil uil-check-circle services__modal-icon"></i>
                  <p className="services__modal-info">Wep page development.</p>
                </li>

                <li className="services__modal-service">
                  <i className="uil uil-check-circle services__modal-icon"></i>
                  <p className="services__modal-info">
                    I create ux element interactions.
                  </p>
                </li>

                <li className="services__modal-service">
                  <i className="uil uil-check-circle services__modal-icon"></i>
                  <p className="services__modal-info">
                    I position your company.
                  </p>
                </li>

                <li className="services__modal-service">
                  <i className="uil uil-check-circle services__modal-icon"></i>
                  <p className="services__modal-info">
                    Design and mockups of products for companies.
                  </p>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="services__content">
          <i className="bx bxl-react services__icon"></i>
          <h3 className="services__title">
           React Js <br />
            Developer
          </h3>

          <span className="services__button"  onClick={()=>toggleTap(2)}>
            View More
            <i className="uil uil-arrow-right services__button-icon"></i>
          </span>

          <div className={toggleState===2?"services__modal active-modal":"services__modal"} onClick={()=>toggleTap(0)}>
            <div className="services__modal-content">
              <i className="bx bx-x services__modal-close"onClick={()=>toggleTap(0)}></i>
              <h3 className="services__modal-title">React js Developer</h3>
              <p className="services__modal-description">
                Service with more than 3 years of experience. providing quality
                work to clients and companies.{" "}
              </p>
              <ul className="services__modal-services grid">
                <li className="services__modal-service">
                  <i className="uil uil-check-circle services__modal-icon"></i>
                  <p className="services__modal-info">
                    develop the user interface.
                  </p>
                </li>

                <li className="services__modal-service">
                  <i className="uil uil-check-circle services__modal-icon"></i>
                  <p className="services__modal-info">Wep page development.</p>
                </li>

                <li className="services__modal-service">
                  <i className="uil uil-check-circle services__modal-icon"></i>
                  <p className="services__modal-info">
                    I create ux element interactions.
                  </p>
                </li>

                <li className="services__modal-service">
                  <i className="uil uil-check-circle services__modal-icon"></i>
                  <p className="services__modal-info">
                    I position your company.
                  </p>
                </li>

                <li className="services__modal-service">
                  <i className="uil uil-check-circle services__modal-icon"></i>
                  <p className="services__modal-info">
                    Design and mockups of products for companies.
                  </p>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="services__content">
          <i className="bx bxl-nodejs services__icon"></i>
          <h3 className="services__title">
           Node JS <br />
            Developer
          </h3>

          <span className="services__button"  onClick={()=>toggleTap(3)}>
            View More
            <i className="uil uil-arrow-right services__button-icon"></i>
          </span>

          <div className={toggleState===3?"services__modal active-modal":"services__modal"} onClick={()=>toggleTap(0)}> 
            <div className="services__modal-content">
            <i class='bx bx-x services__modal-close'onClick={()=>toggleTap(0)} ></i>  
            <h3 className="services__modal-title">Node JS      Developer</h3>
              <p className="services__modal-description">
                Service with more than 3 years of experience. providing quality
                work to clients and companies.{" "}
              </p>

              <ul className="services__modal-services grid">
                <li className="services__modal-service">
                  <i className="uil uil-check-circle services__modal-icon"></i>
                  <p className="services__modal-info">
                    develop the user interface.
                  </p>
                </li>

                <li className="services__modal-service">
                  <i className="uil uil-check-circle services__modal-icon"></i>
                  <p className="services__modal-info">Wep page development.</p>
                </li>

                <li className="services__modal-service">
                  <i className="uil uil-check-circle services__modal-icon"></i>
                  <p className="services__modal-info">
                    I create ux element interactions.
                  </p>
                </li>

                <li className="services__modal-service">
                  <i className="uil uil-check-circle services__modal-icon"></i>
                  <p className="services__modal-info">
                    I position your company.
                  </p>
                </li>

                <li className="services__modal-service">
                  <i className="uil uil-check-circle services__modal-icon"></i>
                  <p className="services__modal-info">
                    Design and mockups of products for companies.
                  </p>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="services__content">
          <i className="bx bx-palette services__icon"></i>
          <h3 className="services__title">
           UI/UX <br />
            Designer
          </h3>

          <span className="services__button"  onClick={()=>toggleTap(4)}>
            View More
            <i className="uil uil-arrow-right services__button-icon"></i>
          </span>

          <div className={toggleState===4?"services__modal active-modal":"services__modal"} onClick={()=>toggleTap(0)}>
            <div className="services__modal-content">
            <i class='bx bx-x services__modal-close'onClick={()=>toggleTap(0)} ></i>  
            <h3 className="services__modal-title">UI/UX            Designer</h3>
              <p className="services__modal-description">
                Service with more than 3 years of experience. providing quality
                work to clients and companies.{" "}
              </p>

              <ul className="services__modal-services grid">
                <li className="services__modal-service">
                  <i className="uil uil-check-circle services__modal-icon"></i>
                  <p className="services__modal-info">
                    develop the user interface.
                  </p>
                </li>

                <li className="services__modal-service">
                  <i className="uil uil-check-circle services__modal-icon"></i>
                  <p className="services__modal-info">Wep page development.</p>
                </li>

                <li className="services__modal-service">
                  <i className="uil uil-check-circle services__modal-icon"></i>
                  <p className="services__modal-info">
                    I create ux element interactions.
                  </p>
                </li>

                <li className="services__modal-service">
                  <i className="uil uil-check-circle services__modal-icon"></i>
                  <p className="services__modal-info">
                    I position your company.
                  </p>
                </li>

                <li className="services__modal-service">
                  <i className="uil uil-check-circle services__modal-icon"></i>
                  <p className="services__modal-info">
                    Design and mockups of products for companies.
                  </p>
                </li>
              </ul>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
};

export default Services;
